const groupBy = (data, cb) => {
  const ret = {};

  data.forEach((item) => {
    const k = cb(item);
    if (!ret[k]) ret[k] = [];
    ret[k].push(item);
  });

  return ret;
};

export default groupBy;
